import { z } from 'zod';

import { ServiceDetails } from './service-details';

const FacilityType = z.object({
  type: z.string(),
});

export const Facility = z.object({
  facility_name: z.string(),
  facility_types: z.nullable(z.array(FacilityType)),
  address: z.string(),
  city: z.string(),
  state: z.string(),
  zip_code: z.string(),
  country: z.string(),
  region: z.string().nullable(),
  primary_contact: z.nullable(z.string().optional()),
  email: z.nullable(z.string().optional()),
  phone_number: z.string().nullable(),
  epa_id: z.string().nullable(),
  pin_categories: z.string().nullable(),
  services: z.nullable(z.array(ServiceDetails)),
  latitude: z.string().nullable(),
  longitude: z.string().nullable(),
});

export type Facility = z.infer<typeof Facility>;
